import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.scss']
})
export class ReportesComponent {

  constructor(private loginService:LoginService) { }

  clickGuard(){
    this.loginService.clickGuard = true;
 }

}
